import { defineComponent as _defineComponent } from 'vue';
import { useListMetricAssignmentsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'CarryCompanyPreview',
  props: {
    ventureId: null,
    ventureName: null
  },
  setup: function setup(__props) {
    var props = __props;
    var IMPACT_CARRY_CONCEPT_ID = 9876;
    var panel = ref(null);
    var enabled = computed(function () {
      return panel.value === 0;
    });
    var _useListMetricAssignm = useListMetricAssignmentsQuery(computed(function () {
        return {
          filters: {
            impactConceptIds: [IMPACT_CARRY_CONCEPT_ID]
          },
          assigneeIds: [props.ventureId],
          limit: -1,
          offset: 0
        };
      }), function () {
        return {
          enabled: enabled.value,
          fetchPolicy: 'network-only'
        };
      }),
      result = _useListMetricAssignm.result,
      loading = _useListMetricAssignm.loading;
    var carryAssignments = computed(function () {
      var _result$value$listMet, _result$value;
      return (_result$value$listMet = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listMetricAssignments) !== null && _result$value$listMet !== void 0 ? _result$value$listMet : [];
    });
    return {
      __sfc: true,
      IMPACT_CARRY_CONCEPT_ID: IMPACT_CARRY_CONCEPT_ID,
      props: props,
      panel: panel,
      enabled: enabled,
      result: result,
      loading: loading,
      carryAssignments: carryAssignments
    };
  }
});